import React from "react";
import { Apple, Play, Smartphone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/lib/app-links";

export default function MobileAppCard() {
  return (
    <Card className="glass-panel mb-6">
      <CardContent className="p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="w-11 h-11 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
          <Smartphone className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold">Use Crystal HACCP on mobile</div>
          <p className="text-sm text-muted-foreground">
            Your team completes checks on iPhone, iPad and Android; everything lands here.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold cta-primary shrink-0"
        >
          <Apple size={16} /> App Store
        </a>
        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold cta-primary shrink-0"><Play size={16} /> Google Play</a>
        </div>
      </CardContent>
    </Card>
  );
}